import React, { lazy } from 'react';

// Lazy-loaded page components (code-split per page)
const CommissionsPaid = lazy(() => import('./CommissionsPaid'));
const CommissionsReport = lazy(() => import('./CommissionsReport'));
const CommissionsToPay = lazy(() => import('./CommissionsToPay'));
const CorrespondentAccountBalance = lazy(() => import('./CorrespondentAccountBalance'));
const CorrespondentConciliation = lazy(() => import('./CorrespondentConciliation'));
const CorrespondentImportSubsidiariesPage = lazy(() => import('./CorrespondentImportSubsidiariesPage'));
const CorrespondentRequestsManagement = lazy(() => import('./CorrespondentRequestsManagement'));
const ImportSubsidiariesSchedulesPage = lazy(() => import('./ImportSubsidiariesSchedulePage'));
const ReportCashRegister = lazy(() => import('./ReportCashRegister'));
const RolesByCorrespondent = lazy(() => import('./RolesByCorrespondent'));
const Subsidiaries = lazy(() => import('./Subsidiaries'));
const UsersImportPage = lazy(() => import('./UsersImportPage'));
const WhiteList = lazy(() => import('./WhiteList'));

// Exported for direct route usage in NestedRouting (not permission-based)
export const HomePage = lazy(() => import('./Homepage'));

/**
 * Subpages feature permission-to-component map.
 * Keys match the `name` field from backend permissions.
 */
export const subpagesPages = (displayName: string): Record<string, React.ReactNode> => ({
  crpdntPaidBonuses: <CommissionsPaid />,
  commissionsReport: <CommissionsReport />,
  crpdntToPayBonuses: <CommissionsToPay />,
  accountBalance: <CorrespondentAccountBalance />,
  correspondentConciliation: <CorrespondentConciliation title={displayName} />,
  subsidiaryManagementBulk: <CorrespondentImportSubsidiariesPage />,
  crpndntRequestManagement: <CorrespondentRequestsManagement />,
  subsidiaryScheduleManagementBulk: <ImportSubsidiariesSchedulesPage />,
  repCashRegisters: <ReportCashRegister />,
  rolesByCrsp: <RolesByCorrespondent />,
  subsidiaryManagement: <Subsidiaries title={displayName} />,
  usersManagementBulk: <UsersImportPage />,
  whiteList: <WhiteList title={displayName} />,
});
